<template>
  <div>
    <stock-header></stock-header>
    <div class="container">
      <el-row :gutter="10">
        <el-col :span="14">
          <div id="stockDetailed">
            <el-card class="box-card stockCard" shadow="never">
              <el-row>
                <el-col :span="24">
                  <h3 class="stockTitle">
                    <i class="el-icon-s-marketing"></i>&nbsp;&nbsp;{{ stockName }}&nbsp;&nbsp;<span class="stockSubhead">({{ symbolSubStr }})</span>
                    <el-button v-if="concernStatus" type="primary" plain size="mini" style="float: right;" @click="join_concern">加入自选</el-button>
                    <el-button v-else type="warning" plain size="mini" style="float: right;" @click="cancel_concern">取消自选</el-button>
                  </h3>
                </el-col>
                <el-col :span="8" class="stockInfoLeft">
                  <el-row>
                    <el-col :span="15" v-if="priceChange">
                      <h3 class="trade green" v-if="priceChange.substr(0, 1) === '-'">{{ nowPrice }}<i class="el-icon-bottom" style="font-weight: 900"></i></h3>
                      <h3 class="trade red" v-else>{{ nowPrice }}<i class="el-icon-top" style="font-weight: 900"></i></h3>
                    </el-col>
                    <el-col :span="5" v-if="priceChange">
                      <div class="pricechange green" v-if="priceChange.substr(0, 1) === '-'">
                        <p>{{ priceChange }}</p>
                        <p>{{ changePercent }}%</p>
                      </div>
                      <div class="pricechange red" v-else>
                        <p>+{{ priceChange }}</p>
                        <p>+{{ changePercent }}%</p>
                      </div>
                    </el-col>

                    <el-col :span="24" v-if="stockDateTime">
                      <p class="center stockTime">{{ stockDateTime }}</p>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="3">
                  <div class="stockInfoTitle text-right stockColor">
                    <p>今 开：</p>
                    <p>最 高：</p>
                    <p>最 低：</p>
                    <p>昨 收：</p>
                  </div>
                </el-col>
                <el-col :span="2">
                  <div class="stockInfoTitle text-left stockColor">
                    <p>{{ todayOpen }}</p>
                    <p>{{ highest }}</p>
                    <p>{{ lowest }}</p>
                    <p>{{ yesReceived }}</p>
                  </div>
                </el-col>
                <el-col :span="2">
                  <div class="stockInfoTitle text-right stockColor">
                    <p>成交量：</p>
                    <p>成交额：</p>
                    <p v-if="marketCapitalization">总市值：</p>
                    <p v-if="circulationValue">流通值：</p>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="stockInfoTitle text-left stockColor">
                    <p>{{ Number((stockVolume /10000).toFixed(2)).toLocaleString(3) }}万手</p>
                    <p>{{ Number((turnover /10000).toFixed(2)).toLocaleString(3) }}亿元</p>
                    <p v-if="marketCapitalization">{{ marketCapitalization }}亿元</p>
                    <p v-if="circulationValue">{{ circulationValue }}亿元</p>
                  </div>
                </el-col>
                <el-col :span="2">
                  <div class="stockInfoTitle text-right stockColor">
                    <p>振 幅：</p>
                    <p v-if="turnoverRate">换手率：</p>
                  </div>
                </el-col>
                <el-col :span="2">
                  <div class="stockInfoTitle text-left stockColor">
                    <p>{{ amplitude }}%</p>
                    <p v-if="turnoverRate">{{ turnoverRate }}%</p>
                  </div>
                </el-col>
              </el-row>
            </el-card>
            <Vue-kline :klineParams="klineParams" :klineData="klineData" ref="callMethods" @refreshKlineData="refreshKlineData"></Vue-kline>
          </div>
        </el-col>
        <el-col :span="10">
          <stock-trading></stock-trading>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import eventBus from "../assets/js/eventBus";
  import StockHeader from "@/components/stockheader";

  import StockCard from "@/components/stockcard";
  import VueKline from "vue-kline";
  import $ from "jquery";
  import StockTrading from "@/components/stocktrading";
  // import Kline from 'kline';

    export default {
      name: "stockdetailed",
      components:{
        StockHeader,
        StockCard,
        VueKline,
        StockTrading
      },
      props:['range'],
      data() {
        return {
          symbolSubStr:"",
          klineParams: {
            width: 1000,
            height: 500,
            theme: "light",
            language: "zh-cn",
            ranges: ["1w", "1d", "1h", "30m", "15m", "5m", "1m", "line"],
            symbol: this.$route.query.symbol,
            symbolName: '上证指数',
            intervalTime: 1000,
            depthWidth: 50,
            count: 1,
          },
          klineData: {},
          stocInfokData : [],
          screenwidth:'',
          concernStatus:true,
          stockName: "",
          nowPrice: "",
          priceChange: "",
          changePercent: "",
          stockDateTime: "",
          todayOpen: "",
          highest: "",
          lowest: "",
          yesReceived: "",
          stockVolume: "",
          turnover: "",
          turnoverRate: "",
          amplitude: "",
          circulationValue: "",
          marketCapitalization: "",
        };
      },
      methods: {
        requestData(time) {
          let that = this;
          that
            .$http({
              url: "/",             //请求地址
              method: "POST",
              data: {
                'nozzle': 'kline',
                'k': time,
                'symbol': this.$route.query.symbol
              }
          }  )
            .then(ret => {
              let resData = ret.data;

              let klineData = {};
              if (resData.data.lines.length > 0) {
                klineData.success = true;
                klineData.data = {};
                klineData.data.lines = [];
                for (let i = 0, len = resData.data.lines.length; i < len; i++) {
                  resData.data.lines[i].splice(6);
                  klineData.data.lines[i] = resData.data.lines[i];

                  for (let j = 0, len2 = resData.data.lines[i].length; j < len2; j++) {
                    switch (j) {
                      case 0:
                        if (time == 'day' || time == 'week'){
                          klineData.data.lines[i][j] = new Date(resData.data.lines[i][j].slice(0, 4) + '/' + resData.data.lines[i][j].slice(5, 7) + '/' + resData.data.lines[i][j].slice(8, 10)).getTime();
                        }else {
                          klineData.data.lines[i][j] = klineData.data.lines[i][j] * 1000;
                          // klineData.data.lines[i][j] = new Date(resData.data.lines[i][j].slice(0, 4) + '/' + resData.data.lines[i][j].slice(4, 6) + '/' + resData.data.lines[i][j].slice(6, 8) + ' ' + resData.data.lines[i][j].slice(8, 10) + ':' + resData.data.lines[i][j].slice(10)).getTime();
                        }
                        // klineData.data.lines[i][j] = klineData.data.lines[i][j] * 1000;
                        break;
                      case 1:
                        klineData.data.lines[i][j] = Number(resData.data.lines[i][j]);
                          break;
                      case 2:
                        klineData.data.lines[i][4] = Number(resData.data.lines[i][j]);
                        break;
                      case 3:
                        klineData.data.lines[i][2] = Number(resData.data.lines[i][j]);
                        break;
                      case 4:
                        klineData.data.lines[i][3] = Number(resData.data.lines[i][j]);
                        break;
                      default:
                        klineData.data.lines[i][j] = Number(resData.data.lines[i][j]);
                        break;

                    }

                  }
                }
              } else {
                klineData.success = false;
              }
              klineData.success = true;
              that.klineData = klineData;
              that.$refs.callMethods.kline.chartMgr.getChart().updateDataAndDisplay(klineData.data.lines);
              clearInterval(this.timer1);
              this.timer1 = setInterval(function() {
                that.requestData(that.$store.state.klineTime)
              }, 5000);
            });
        },
        refreshKlineData(option) {
          switch (option) {
            case 60000:
              this.$store.commit('changeKlineTime','M1');
              this.requestData('M1');
              break;
            case 300000:
              this.$store.commit('changeKlineTime','M5');
              this.requestData('M5');
              break;
            case 900000:
              this.$store.commit('changeKlineTime','M15');
              this.requestData('M15');
              break;
            case 1800000:
              this.$store.commit('changeKlineTime','M30');
              this.requestData('M30');
              break;
            case 3600000:
              this.$store.commit('changeKlineTime','M60');
              this.requestData('M60');
              break;
            case 86400000:
              this.$store.commit('changeKlineTime','day');
              this.requestData('day');
              break;
            case 604800000:
              this.$store.commit('changeKlineTime','week');
              this.requestData('week');
              break;
          }
        },
        getStockInfo(){
          let that = this;
          let symbol = this.$route.query.symbol;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "shuhai_price",
                code: symbol,
                withcode: 0,
              },
            })
            .then(function (res) {
              if (res.data.code == 1) {
                that.symbolSubStr = that.$route.query.symbol.substr(2);
                let elements = res.data.data[0];
                that.stockName = elements.Name;
                that.nowPrice = (elements.NewPrice).toFixed(3);
                that.yesReceived = elements.LastClose;
                that.todayOpen = elements.Open;
                that.stockVolume = elements.Volume;
                that.stockDateTime = that.$moment.unix(elements.Date).format("MM/DD/YYYY");               
                that.priceChange = (that.nowPrice - that.yesReceived)
                  .toFixed(3)
                  .toString(); //elements[31];
                that.changePercent = (
                  (that.priceChange / that.yesReceived) *
                  100
                ).toFixed(3); //elements[32];
                // that.turnover = elements[37];
                // that.turnoverRate = elements[38];
                that.highest = elements.High;
                that.lowest = elements.Low;
                that.amplitude = (
                  ((that.highest - that.lowest) * 100) /
                  that.yesReceived
                ).toFixed(2); //elements[43];
                that.circulationValue = 0; //elements[44];
                that.marketCapitalization = 0; //elements[45];

                that.$store.commit("addStocksVisited", {
                  symbol: that.$route.query.symbol,
                  symbolName: that.stockName,
                  trade: that.nowPrice,
                  changepercent: that.changePercent,
                });
                that.$refs.callMethods.setSymbol(
                  that.$route.query.symbol,
                  elements[1]
                );
              }
            });
            
          // $.ajax({
          //   url: "https://qt.gtimg.cn/q=" + symbol,
          //   type: "GET",
          //   dataType: "script",
          //   cache: true,
          //   success: function() {
          //     var elements = eval("v_" + symbol).split("~");
          //     that.stocInfokData = elements;
          //     that.$store.commit('addStocksVisited',{symbol:that.$route.query.symbol,symbolName:that.stocInfokData[1],trade:that.stocInfokData[3],changepercent:that.stocInfokData[32]});
          //     that.$refs.callMethods.setSymbol(that.$route.query.symbol,elements[1]);
          //   }
          // });

          /*that
            .$http({
            url: "/",
            method: "POST",
            data: {
              'nozzle': 'stockdetail',
              'symbol': this.$route.query.symbol
            }
          })
            .then(ret => {
              let resData = ret.data;
              if (resData.code === 1){
                that.stocInfokData = resData.data;
                // this.KLine.setSymbol(that.$route.query.symbol,resData.data[1]);
                that.$refs.callMethods.setSymbol(that.$route.query.symbol,resData.data[1]);
                that.$store.commit('addStocksVisited',{symbol:that.$route.query.symbol,symbolName:that.stocInfokData[1],trade:that.stocInfokData[3],changepercent:that.stocInfokData[32]});
              }/!*else{
                that.$alert('请稍后尝试','提示',{
                  confirmButtonText: '确定',
                  callback: action => that.getStockInfo()
                })
              }*!/
            });*/
        },
        //加入自选
        join_concern(){
          let that = this;
          let symbol = this.$route.query.symbol.replace(/[^0-9]/ig,"");
          if (this.$store.state.loginType){
            that.$http({
              url: "/",             //请求地址
              method: "POST",
              data: {
                'nozzle': 'join_concern',
                'token': window.sessionStorage.getItem('token'),
                'code': symbol
              }
            })
              .then(ret => {
                that.$message({
                  message: ret.data.msg,
                  type: "success",
                  duration: 1000,
                  onClose:function () {
                    that.concernStatus = false;
                    eventBus.$emit("concern");
                  }
                });
              });
          }else{
            that.$message.error({
              message:'您还未登录,请前去登录',
              onClose:function () {
                that.$router.push('/login')
              }
            });
          }

        },
        //取消自选
        cancel_concern(){
          let that = this;
          let symbol = this.$route.query.symbol.replace(/[^0-9]/ig,"");
          if (this.$store.state.loginType){
            that.$http({
              url: "/",             //请求地址
              method: "POST",
              data: {
                'nozzle': 'cancel_concern',
                'token': window.sessionStorage.getItem('token'),
                'code': symbol
              }
            })
              .then(ret => {
                that.$message({
                  message: ret.data.msg,
                  type: "success",
                  duration: 1000,
                  onClose:function () {
                    that.concernStatus = true;
                  }
                });
              });
          }else{
            that.$message.error({
              message:'您还未登录,请前去登录',
              onClose:function () {
                that.$router.push('/login')
              }
            });
          }
        },
        onResize(width, height){

        },
        getUserConcern(){
          let that = this;
          that.$http({
              url: "/",
              method: "POST",
              data: {
                'nozzle': 'concern',
                token: sessionStorage.getItem("token")
              }
            })
            .then(ret => {
              let resData = ret.data;
              if (resData.code === 1){
                let symbol = this.$route.query.symbol.replace(/[^0-9]/ig,"");
                let dataArr = resData.data;
                for (let i = 0,len = dataArr.length; i < len; i++){
                  if (symbol == dataArr[i].code){
                    that.concernStatus = false;
                  }
                }
              }
            });
        },
      },
      mounted: function () {
        let that = this;
        // this.reload();
        if (that.$store.state.loginType){
          this.getUserConcern();
        }
        this.getStockInfo();

        if (that.$store.state.accessNumber === 0){
          that.$store.commit('changeAccessNumber')
        }else{
          that.requestData(that.$store.state.klineTime)
        }
        this.chatTimer = setInterval(function () {
          that.getStockInfo();
        },10000);
        this.$refs.callMethods.resize(document.getElementById('stockDetailed').clientWidth, 500);
        //持续
        window.onresize = function () {
          that.screenwidth = document.getElementById('stockDetailed').clientWidth;
          that.$refs.callMethods.resize(that.screenwidth, 500);
        }
      },
      watch:{
        $route(to,from){
          //this.reload();
          this.requestData(this.$store.state.klineTime);
          this.getStockInfo();
        },
        /*screenwidth:{
          immediate:true,
          handler:function (value) {
          }
        }*/
      },
      beforeDestroy() {
        clearTimeout(this.chatTimer);
        clearTimeout(this.timer1);
      }
    }
</script>

<style scoped>
  .container {
    width: 100%;
    max-width: 1200px;
    min-width: 1000px;
    margin: 10px auto;
  }
  .stockCard {
    height: 160px;
    margin-bottom: 10px;
    overflow: hidden;
  }
  .stockTitle{
    color: rgb(1, 39, 147);
    font-size: 24px;
    border-bottom: 2px solid rgb(1, 39, 147);
  }
  .stockSubhead{
    font-size: 12px;
  }
  .trade{
    text-align: right;
    font-size: 24px;
    border-bottom: 1px solid #EBEEF5;
    padding-top: 35px;
    padding-bottom: 10px;
  }
  .stockInfoLeft{
    border-right: 1px solid #EBEEF5;
  }
  .pricechange{
    padding-top: 35px;
    padding-bottom: 10px;
    font-size: 12px;
    border-bottom: 1px solid #EBEEF5;
  }
  .stockTime{
    padding-top: 10px;
    font-size: 12px;
    color: rgb(1, 39, 147);
    padding-bottom: 20px;
  }
  .stockInfoTitle{
    font-size: 12px;
    padding-top: 10px;
    line-height: 20px;
  }
  .text-right{
    text-align: right;
  }
  .text-left{
    text-align: left;
  }
  .green{
    color: #008000;
  }
  .stockColor{
    color: rgb(1, 39, 147);
  }
  .m-line{
    width: 100%;
    height: 500px;
  }
  .K-line{
    width: 100%;
    height: 500px;
  }
</style>



// WEBPACK FOOTER //
// src/components/stockdetailed.vue